<template>
  <div class="pl-3 pr-3 pt-1 pb-1 border-bottom">
    <div class="d-flex flex-row justify-content-between align-items-start">
      <div class="w-100">
        <div class="d-flex flex-row justify-content-between align-items-center">
          <div style="max-width: 12rem">
            <img v-if="selected" :src="require('../assets/icons/check.png')" />
            {{ eoc.patient | formatClient }}
          </div>
          <div class="d-flex align-items-center" style="max-width: 12rem">
            <div
              v-if="eoc.levelOfCare"
              class="badge text-white mr-2 ml-2"
              :style="{ backgroundColor: eoc.levelOfCare.color }"
            >
              <span class="text-wrap">{{ eoc.levelOfCare.name }}</span>
            </div>
            <b-badge :variant="statusVariant(eoc.status)" class="text-white">{{
              statusText(eoc.status)
            }}</b-badge>
          </div>
        </div>
        <div
          class="d-flex flex-row justify-content-between admission-data color-custom-dark-grey"
        >
          <span
            >MR#:
            {{
              {
                mrn: eoc.patient.mrn,
                eocn: eoc.eocn
              } | formatMrn
            }}
          </span>
          <span
            >{{ eoc.startDate | formatDateOnly }} -
            {{ eoc.endDate | formatDateOnly }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EocFilterOptionTemplate",
  props: ["eoc", "selected"],
  methods: {
    statusVariant(status) {
      switch (status) {
        case "Pending":
          return "warning";
        case "Active":
          return "success";
        case "Inactive":
          return "danger";
        default:
          return "";
      }
    },
    statusText(status) {
      switch (status) {
        case "Pending":
          return "PENDING";
        case "Active":
          return "ACTIVE";
        case "Inactive":
          return "INACTIVE";
        default:
          return "";
      }
    }
  }
};
</script>

<style scoped>
.admission-data {
  font-size: 13px;
}
</style>
